import { ValueAndLabel } from "./valueAndLabel.model";

export enum WithdrawalRequestReason {
    FoundByEmb = 1,
    FoundByAnotherService,
    NotFound,
    DissatisfactionService,
    Expensive,
    UseAnotherService,
    UseAnotherMarriageAgency,
    DifficultHowToUse,
    TroublesomeToSubmitCertificate,
    FewSeriousMembers,
    FewMembersAsDesired,
    CouldNotMatch,
    ExpensiveThanOtherMarriageAgency,
    FewMembersThanOtherApps,
    FewMembersThanOtherMarriageAgency
}

export const WITHDRAWAL_REQUEST_REASONS: ValueAndLabel[] = [
    {
        id: WithdrawalRequestReason.FoundByEmb,
        text: "本サービスでお相手が見つかった"
    },
    {
        id: WithdrawalRequestReason.FoundByAnotherService,
        text: "他のサービスでお相手が見つかった"
    },
    {
        id: WithdrawalRequestReason.NotFound,
        text: "お相手は見つかってないが、婚活をやめる"
    },
    {
        id: WithdrawalRequestReason.UseAnotherService,
        text: "他のマッチングアプリを利用したい"
    },
    {
        id: WithdrawalRequestReason.UseAnotherMarriageAgency,
        text: "他の結婚相談所を利用したい"
    },
    {
        id: WithdrawalRequestReason.DifficultHowToUse,
        text: "使い方がよく分からなかった"
    },
    {
        id: WithdrawalRequestReason.TroublesomeToSubmitCertificate,
        text: "証明書の提出が面倒"
    },
    {
        id: WithdrawalRequestReason.FewSeriousMembers,
        text: "本気度の高そうな会員が少ない"
    },
    {
        id: WithdrawalRequestReason.FewMembersAsDesired,
        text: "希望にあった会員が少ない"
    },
    {
        id: WithdrawalRequestReason.CouldNotMatch,
        text: "マッチングやコンタクトができなかった"
    },
    {
        id: WithdrawalRequestReason.DissatisfactionService,
        text: "アプリの機能が充実していない"
    },
    {
        id: WithdrawalRequestReason.Expensive,
        text: "他のマッチングアプリと比べて、料金が高い"
    },
    {
        id: WithdrawalRequestReason.ExpensiveThanOtherMarriageAgency,
        text: "他の結婚相談所と比べて、料金が高い"
    },
    {
        id: WithdrawalRequestReason.FewMembersThanOtherApps,
        text: "他のマッチングアプリと比べて、会員数が少ない"
    },
    {
        id: WithdrawalRequestReason.FewMembersThanOtherMarriageAgency,
        text: "他の結婚相談所と比べて、会員数が少ない"
    }
];

export const WITHDRAWAL_REQUEST_REASONS_HEADLINE: {
    content: WithdrawalRequestReason[];
    text: string;
}[] = [
    {
        content: [
            WithdrawalRequestReason.FoundByEmb,
            WithdrawalRequestReason.FoundByAnotherService,
            WithdrawalRequestReason.NotFound
        ],
        text: "婚活をやめるため"
    },
    {
        content: [
            WithdrawalRequestReason.UseAnotherService,
            WithdrawalRequestReason.UseAnotherMarriageAgency
        ],
        text: "他のサービスへ乗り換えるため"
    },
    {
        content: [
            WithdrawalRequestReason.DifficultHowToUse,
            WithdrawalRequestReason.TroublesomeToSubmitCertificate,
            WithdrawalRequestReason.FewSeriousMembers,
            WithdrawalRequestReason.FewMembersAsDesired,
            WithdrawalRequestReason.CouldNotMatch,
            WithdrawalRequestReason.DissatisfactionService
        ],
        text: "サービス内容が不満なため"
    },
    {
        content: [
            WithdrawalRequestReason.Expensive,
            WithdrawalRequestReason.ExpensiveThanOtherMarriageAgency
        ],
        text: "料金が高いため"
    },
    {
        content: [
            WithdrawalRequestReason.FewMembersThanOtherApps,
            WithdrawalRequestReason.FewMembersThanOtherMarriageAgency
        ],
        text: "会員数が少ないため"
    }
];
